import React, { useEffect, useState, useRef } from "react";
import "./css/HiringCarousel.css";

const slides = [
  {
    src: "./scholarshiptest.jpg",
    alt: "Scholarship Test",
    description: "Scholarship Test (Click on the image to apply)",
    link: "https://docs.google.com/forms/d/e/1FAIpQLSeKN-w8RbJUlc07OWm1McOsaq1IxDLxzaJ7PXqogRdpg5ROmA/viewform?usp=dialog",
  },
  {
    src: "./Students/international-day-education-cartoon-style.jpg",
    alt: "Admissions Open",
    description:
      "Admissions Open - For classes 7th to 10th (Click on the image to apply)",
    link: "https://docs.google.com/forms/d/e/1FAIpQLScB49PvB37VC70no_BJ9K3DnRVOrLl-APXwwoUPEhK_6rw1MA/viewform?usp=dialog",
  },
  {
    src: "./hiring.jpg",
    alt: "Hiring",
    description: "Hiring (Click on the image to apply)",
    link: "https://docs.google.com/forms/d/e/1FAIpQLSfguREmrBlBADnUkFhzO7w_r79O_WMhzjvCgn4uLWAWnnI_wA/viewform?usp=dialog",
  },
];

const HiringCarousel = () => {
  const [current, setCurrent] = useState(0);
  const intervalRef = useRef(null);

  const nextSlide = () => {
    setCurrent((prev) => (prev + 1) % slides.length);
    resetInterval();
  };

  const prevSlide = () => {
    setCurrent((prev) => (prev - 1 + slides.length) % slides.length);
    resetInterval();
  };

  const resetInterval = () => {
    clearInterval(intervalRef.current);
    intervalRef.current = setInterval(() => {
      setCurrent((prev) => (prev + 1) % slides.length);
    }, 5000);
  };

  useEffect(() => {
    resetInterval();
    return () => clearInterval(intervalRef.current);
  }, []);

  return (
    <div className="outer-container">
      <h2 className="heading-text">For Akbarpur offline centre</h2>
      <div className="carousel-container">
        {slides.map((slide, index) => (
          <div
            key={index}
            className={`carousel-slide ${index === current ? "active" : ""}`}
            onClick={() => {
              if (index === current) window.open(slide.link, "_blank");
            }}
            style={{ pointerEvents: index === current ? "auto" : "none" }}
          >
            <img src={slide.src} alt={slide.alt} className="responsive-image" />
            <p className="image-description">
              <strong>{slide.description}</strong>
            </p>
          </div>
        ))}

        {/* Arrows */}
      </div>
      <button className="arrow left-arrow" onClick={prevSlide}>
        &#10094;
      </button>
      <button className="arrow right-arrow" onClick={nextSlide}>
        &#10095;
      </button>
    </div>
  );
};

export default HiringCarousel;
